import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { isDisabled } from '../utils/customPropStyles';
import { DataStore, TranslationStore } from '../stores';
import { getLabel } from '../utils/getLabel';
import Translate, { translate } from './Translate';
import Icon from './Icon';
import { computed } from 'mobx';

const Button = styled<any, any>('button')`
    ${propStyles};
    ${isDisabled};
    &:disabled {
        opacity: 0.5;
    }
`;

Button.defaultProps = {
    display: 'flex',
    flex: ['1 0 0', '0 1 auto'],
    alignItems: 'center',
    justifyContent: 'center',
    paddingX: 'md',
    paddingY: 'sm',
    margin: '0 0 0 10px',
    minHeight: '40px',
    fontSize: 'inherit',
    fontFamily: 'heading',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    boxShadow: 'sm',
    textAlign: 'center',
    color: 'body',
    bgColor: 'gray100',
    cursor: 'pointer',
    outline: 'none',
    selected: {
        color: 'white',
        bgColor: 'primary',
    },
    isDisabled: {
        cursor: 'auto',
    },
};

const DownloadButtonIcon = styled<any, any>(Icon)`
    flex-shrink: 0;
    height: 1.6em;
    width: 1.6em;
`;

DownloadButtonIcon.defaultProps = {
    marginX: 'sm',
};

const ButtonText = styled<any, any>('span')`
    ${propStyles};
`;

ButtonText.defaultProps = {
    display: ['inline'],
};

interface ExplorerDownloadProps {
    theme?: any;
    dataStore?: DataStore;
    translationStore?: TranslationStore;
    disabled?: boolean;
}

@inject('dataStore', 'translationStore')
class ExplorerDownload extends React.Component<ExplorerDownloadProps> {
    @computed
    get hasMinimumFiltersNeeded() {
        const { dataStore } = this.props;
        return dataStore.hasMinimumFiltersNeeded();
    }

    render() {
        const { theme, dataStore, translationStore, disabled } = this.props;
        const downloadConfig =
            dataStore &&
            dataStore.config &&
            dataStore.config.explorer &&
            dataStore.config.explorer.download;
        if (
            !downloadConfig ||
            !downloadConfig.enabled ||
            !this.hasMinimumFiltersNeeded
        ) {
            return null;
        }
        const label = getLabel(downloadConfig.label, 'Download');
        const iconFileName =
            downloadConfig.iconFileName || 'ExplorerDownloadIcon';
        let hideChild = downloadConfig.hideChild || 'none';
        if (dataStore && dataStore.isMobile) {
            hideChild = downloadConfig.hideChildMobile || 'text';
        }
        return (
            <Button
                title={translate(translationStore, label)}
                onClick={dataStore.downloadTable}
                disabled={disabled}
                {...theme.ExplorerDownloadButton}
            >
                {hideChild !== 'text' && (
                    <ButtonText>
                        {label && <Translate>{label}</Translate>}
                    </ButtonText>
                )}
                {hideChild !== 'icon' && (
                    <DownloadButtonIcon
                        fileName={iconFileName}
                        {...theme.ExplorerDownloadButtonIcon}
                    />
                )}
            </Button>
        );
    }
}

export default observer(withTheme(ExplorerDownload)) as any;



// WEBPACK FOOTER //
// ./src/Components/ExplorerDownload.tsx